import type { ReactNode } from "react";

export type CardProps = {
  title?: ReactNode;
  eyebrow?: ReactNode;
  number?: number;
  children: ReactNode;
  as?: "div" | "article" | "li";
  tone?: "light" | "dark";
  className?: string;
};

export function Card({
  title,
  eyebrow,
  number,
  children,
  as: Tag = "article",
  tone = "light",
  className,
}: CardProps) {
  const toneClass = tone === "dark" ? "card-dark" : "card";

  return (
    <Tag
      className={`${toneClass} h-full flex flex-col gap-3 ${className ?? ""}`}
    >
      {number != null ? (
        <span
          aria-hidden="true"
          className="font-display text-4xl leading-none text-brand-red opacity-60"
        >
          {String(number).padStart(2, "0")}
        </span>
      ) : null}
      {eyebrow ? <span className="eyebrow">{eyebrow}</span> : null}
      {title ? (
        <h3 className="text-lg sm:text-xl font-semibold leading-snug tracking-normal normal-case font-sans">
          {title}
        </h3>
      ) : null}
      <div className="text-base leading-relaxed opacity-80">{children}</div>
    </Tag>
  );
}
